import React from 'react';
import TestChat from './testShell/TestChat';
import sdq from './testShell/configs/sdq';

// SDQ in the chat, on the shared test shell (testShell/). Its words, scale and
// save calls live in testShell/configs/sdq.js.
const ChatbotSDQ = (props) => <TestChat config={sdq} {...props} />;

export default ChatbotSDQ;
